import { AccountingCategory, getAccountingCategory } from '@adornis/accounting/base/api/AccountingCategory.js';

/**
 * Martinus uses 2 extra decimal places for accounts and values from the skr-03. In this case we multiply by 100 to get the correct value.
 */
export const MARTINUS_ACCOUNTING_DIGIT_MULTIPLIER = 100;

/**
 * Whether a Personenkonto is a Kreditor: SKR-03 puts Kreditoren at 70000-99999, which is 7000000 and up in
 * Martinus' 7-digit numbering - everything below is a Debitor. Same classifier the import stores on the entries.
 */
export const isKreditorenNummer = (account: string): boolean =>
  getAccountingCategory(account, MARTINUS_ACCOUNTING_DIGIT_MULTIPLIER) === AccountingCategory.CREDITOR;
